import { Component, AfterViewInit } from '@angular/core';
import { DataService } from '../../../../../infrastructure/services/base/config/data.service';

declare var jQuery: any;

@Component({
    selector: 'page-user-manager',
    templateUrl: './user-manager.html',
})
export class UserManagerComponent implements AfterViewInit {

    propertiesPage = {
        "Title": "User Group",
        "TitleDesc": "",
        "BreadcrumbActive": "User Group"
    }

    UserGroupList: any[];
    MenuGroupList: any[];
    AccountList: any[];
    overLayBoxList: boolean = true;

    constructor(private dtService: DataService) { }

    getUserGroupList(): void {
        this.dtService.getJSON("../../assets/mock-data/user-group-list.json")
            .subscribe(
            data => this.UserGroupList = data.UserGroupList,
            error => console.log(error),
            // () => console.log("Finished Call DeliveryTypes")
        );
    }
    getMenuGroupList(): void {
        this.dtService.getJSON("../../assets/mock-data/menu-group-list.json")
            .subscribe(
            data => this.MenuGroupList = data.MenuUserGroupList,
            error => console.log(error),
            // () => console.log("Finished Call DeliveryTypes")
        );
    }
    
    getAccountList(): void {
        this.dtService.getJSON("../../assets/mock-data/account.json")
            .subscribe(
            data => this.AccountList = data.Account,
            error => console.log(error),
            // () => console.log("Finished Call DeliveryTypes")
        );
    }

    ngOnInit(): void {
        this.getUserGroupList();
        this.getMenuGroupList();
        this.getAccountList();
    }

    ngAfterViewInit() {
       console.log(1);

    }

    btnSearchClick(): void {
        this.overLayBoxList = !this.overLayBoxList;
    }




}


// WEBPACK FOOTER //
// ./src/app/views/pages/base/security/user-manager/user-manager.component.ts